<template>
  <!-- 登录页面的整体布局 -->
  <div class="w-full flex flex-wrap justify-center bg-gray-100">
    
    <!-- 登录区域 -->
    <div class="w-full md:w-1/2 flex flex-col  p-20 bg-white shadow-md rounded-lg  mt-[8rem] mb-[8rem] h-[calc(100vh-16rem)]">

      <!-- 欢迎信息 -->
      <div class="text-center text-3xl mb-8">欢迎使用青云学派管理系统</div>

      <!-- 登录表单 -->
      <form class="flex flex-col pt-3 md:pt-8" onsubmit="event.preventDefault();">
        
        <!-- 用户名输入框 -->
        <div class="flex flex-col pt-4">
          <label for="email" class="text-lg font-semibold">账号</label>
          <input type="email" v-model="form.username" placeholder="用户名"
                 class="shadow appearance-none border rounded w-full py-2 px-3 border-blue-300 text-gray-700 mt-1 leading-tight focus:outline-none focus:shadow-outline">
        </div>

        <!-- 密码输入框 -->
        <div class="flex flex-col pt-4">
          <label for="password" class="text-lg font-semibold">密码</label>
          <input type="password" v-model="form.password" placeholder="密码"
                 class="shadow appearance-none border rounded w-full py-2 px-3 border-blue-300 text-gray-700 mt-1 leading-tight focus:outline-none focus:shadow-outline">
        </div>

        <!-- 图片验证码（目前隐藏） -->
        <div class="flex flex-col pt-4 hidden" id="captcha-section">
          <label for="password" class="text-lg font-semibold">图片验证码</label>
          <div class="flex items-center">
            <input type="text" v-model="form.captcha" placeholder="Captcha"
                   class="shadow appearance-none border rounded w-1/2 py-2 px-3 text-gray-700 mt-1 leading-tight focus:outline-none focus:shadow-outline">
            <img class="w-1/2 inline-block mx-10 cursor-pointer" :src="form.captchaUrl"
                 style="width: 130px;height: 36px;" @click="getCaptcha()" />
          </div>
        </div>

        <!-- 登录按钮 -->
        <input type="button" @click="doLogin" value="登 录"
               class="bg-blue-500 hover:bg-blue-600 text-white font-bold text-lg p-2 mt-8 cursor-pointer rounded transition duration-200">
      </form>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AuthService from '../apis/AuthService'
import SysMenuService from '../apis/SysMenuService';
import { GlobalConsts } from '../config'
import CommonUtils from '../utils/CommonUtils'
import { useMenuStore } from "../store/menuStore";
import Md5 from '../utils/Md5Util';
const router = useRouter()
const mainMenu = useMenuStore();
// const userStore = useUserStore()
let form = reactive({
  username: '',
  password: '',
  // captcha: '',
  // captchaUrl: '',
  // captchaKey: ''
})
const getCaptcha = () => {
  // AuthService.getCaptcha().then(res => {
  //   if (resp.code == 200) {
  //     form.captchaUrl = res.data.captchaUrl;
  //     form.captchaKey = res.data.captchaKey
  //   }
  // })
}
onMounted(() => {
  getCaptcha()
})
const doLogin = () => {
  //doLoginTest()

  // return;
  //router.push("/")
  if (!form.username || !form.password ) {
    ElMessage.error("请填写用户名、密码");
    return;
  }
  AuthService.login({
    username: form.username,
    password:  form.password //Md5.hashStr(form.password),
  }).then(async(res) => {
    if (res.code == 1) {
      // success data { token,username }
      CommonUtils.setLocalStore(GlobalConsts.TokenKey, res.data.token);
      CommonUtils.setLocalStore(GlobalConsts.CurrentLoginUserName, res.data.username);
      
      // CommonUtils.setLocalStore(GlobalConsts.CurrentLoginUserNo, res.data.gopUser.userNo);
      // CommonUtils.setLocalStore(GlobalConsts.CurrentLoginUserRoleId, res.data.gopUser.roleId);
      //CommonUtils.setLocalStore(GlobalConsts.MenuUrl, JSON.stringify(res.data.menuUrl));
      //updatePwdFlag 是否要修改密码1不修改2需要修改
      CommonUtils.setLocalStore(GlobalConsts.UPDATE_PWD_FLAG, res.data.updatePwdFlag);
      let menuItems = res.data.menuTreeList;
      // this.$store.commit('setMenuItems',menuItems);

      //缓存菜单
      //CommonUtils.setLocalStore(GlobalConsts.MenuItems,JSON.stringify(menuItems));
      CommonUtils.setLocalStore(GlobalConsts.CurrentMenuTreeList,JSON.stringify(menuItems));
      CommonUtils.setLocalStore(GlobalConsts.UserInfo,res.data.username);

      setTimeout(async()=>{
        await mainMenu.setMenus()
        ElMessage.success("登录成功")
        router.push("/")
      })

      // if(resp.code == 200 && resp.data.length>0){
      //   console.log(resp)
      //   CommonUtils.setLocalStore(GlobalConsts.CurrentMenuTreeList,JSON.stringify(resp.data));
      //   setTimeout(async()=>{
      //     await mainMenu.setMenus()
      //     ElMessage.success("登录成功")
      //     router.push("/")
      //   })
      // }else {
      //   ElMessage.error("登录权限错误");
      // }
      
    } else {
      ElMessage.error(res.msg);
    }
  })
}

function doLoginTest(){
  CommonUtils.setLocalStore(GlobalConsts.TokenKey, "res.data.token");
  CommonUtils.setLocalStore(GlobalConsts.CurrentLoginUserName,"res.data.username");
  //userStore.setUsername(res.data.username)
  ElMessage.success("登录成功")
  router.push("/")
}
</script>
